import { Container } from "./Container";
import { SectionHeading } from "./SectionHeading";
import { TimelineItem } from "./TimelineItem";
import { experience } from "../data/portfolio";

export function ExperienceSection() {
  return (
    <section
      id="experience"
      className="border-hairline bg-band border-y py-16 md:py-24"
    >
      <Container>
        <SectionHeading
          eyebrow="Experience"
          title="A practical background in interactive software."
          description="The responsibilities and outcomes most relevant to the work I want next."
        />
        <div className="border-hairline mt-12 border-l pl-9">
          {experience.map((item, index) => (
            <TimelineItem
              key={item.role}
              {...item}
              index={index + 1}
              last={index === experience.length - 1}
            />
          ))}
        </div>
      </Container>
    </section>
  );
}
